import React from 'react';
import { SocialCardData, SocialCard } from './SocialCard';

type Props = {
    viewedAt: any;
};

export const RecruitmentCard: React.FC<Props> = ({ viewedAt }) => {
    const data: SocialCardData = {
        label: 'New Recruitment!',
        subLabel: '',
        picAltText: '',
        profileImg: null,
        slug: '',
        unread: !viewedAt,
        deletedUser: false,
    };

    return (
        <>
            <SocialCard data={data} />
        </>
    );
};
